import { createGlobalStyle, css } from 'styled-components';
import theme from './theme';

const RewriteStyle = createGlobalStyle`${css`
	* {
		--account_deliveryWrapperMTop: var(--sp7x) !important;
		--account_checkoutMTop: var(--sp7x) !important;
		--form_p3: var(--sp2x) !important;
		--form_p2: var(--sp1-5x) !important;

		--account_promoCodeInputPadTB: var(--sp1x) !important;
		--account_promoCodeInputPadLR: var(--sp1-5x) !important;
		--account_balanceInputPadTB: var(--sp1x) !important;
		--account_balanceInputPadLR: var(--sp1-5x) !important;

		--account_checkboxWrapSize: var(--sp2x) !important;
		--account_checkboxDistance: 0px !important;

		--core_popupMaxWidth: 50% !important;
	}

	.fonts-greenST {
		button,
		a,
		p {
			font-size: var(--h5) !important;
		}
	}

	.promo-code-container,
	.balance-container {
		row-gap: 0 !important;
	}

	.cart-items-table-wrap,
	.mobile-cart-items-table-wrap {
		.green-large-text {
			button {
				text-decoration: none !important;
			}
		}
		.content-button {
			font-size: var(--h4) !important;
			color: var(--black) !important;
		}

		.button-gift {
			opacity: 1 !important;
			display: inline-flex;

			button {
				position: relative;
				background-color: var(--lightGreen) !important;
				border: none !important;
				border-radius: var(--sp2-5x) !important;
				padding: var(--sp1x) var(--sp2x) !important;
				box-shadow: 0 5px 0 0 var(--green) !important;
				box-sizing: border-box;
				overflow: hidden;
				display: inline-block;
				width: auto !important;
				font-weight: 500;
				transition: box-shadow 0.3s ease-out;

				.content-button {
					font-size: var(--h5) !important;
				}

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							background-color: var(--lightGreen) !important;
							border: none !important;
							box-shadow: 0 0 0 0 var(--green) !important;
						}
					}
				}
			}
		}
	}

	.sign-up .custom-checkbox-wrap {
		.checkbox-wrap {
			margin-right: var(--sp1x) !important;
		}
		.checkbox-text {
			display: none !important;
		}
	}

	.react-select__menu {
		border: 1px solid var(--grey) !important;
		border-radius: var(--sp3x) !important;

		.react-select__option {
			padding: var(--sp1-5x) var(--sp2x) !important;
		}
	}
	.left-bar-account-balance {
		.inner-wrapper-left-bar {
			.status-title {
				font-size: var(--h3) !important;
			}

			.text-title {
				font-size: var(--h1) !important;
			}
			.status-description {
				font-size: var(--h3) !important;
			}
		}
	}
	.wrapper-progress-inner-info {
		.balance-title {
			font-size: var(--h5) !important;
		}
		.balance-value {
			font-size: var(--h1) !important;
		}
	}

	.account-progress-status-wrapper {
		.title-status-progress {
			font-size: var(--h5);
		}
	}

	.wrapper-history-container {
		p {
			font-size: var(--h5) !important;
		}
	}

	.checkout-address-autofill {
		width: 50% !important;
		padding-right: calc(var(--account_formItemDistance) / 2) !important;
	}

	.spin-loader {
		--spinLoaderBackground: var(--green) !important;
	}

	.cart-items-table-wrap {
		.titles-wrap {
			p {
				color: var(--grey) !important;
			}
		}
	}

	.mobile-cart-item-wrap {
		.mobile-total-price-wrap {
			margin-top: var(--sp0-5x) !important;
			align-items: flex-end !important;
		}
	}

	.sticky-wrap-title {
		color: var(--grey) !important;
	}

	.icon-heart-fill .path2:before,
	.icon-heart-fill .path1:before {
		color: var(--purple) !important;
	}

	.popup-content-container {
		.cancel-and-save-wrap {
			.green-large-text {
				button {
					font-size: var(--h5) !important;
				}
			}
		}
	}

	textarea {
		border-radius: var(--sp3x) !important;
	}

	input {
		padding: var(--sp1x) var(--sp1-5x) !important;
		border-width: 1px !important;
		font-size: var(--sp2x) !important;
		border-radius: var(--sp4x) !important;

		&:not(:placeholder-shown) {
			color: var(--black) !important;
		}
	}

	#subscribe_email {
		padding: var(--sp1x) var(--sp2-5x) !important;
	}

	.icon-back-to-shop {
		transform: rotate(90deg) translateX(1px);
	}

	.sign-up .custom-checkbox-container {
		margin-top: calc((var(--account_p3) * var(--account_lineHeight) - var(--account_p3)) / 2) !important;
	}

	.react-select__control {
		border-width: 1px !important;
		border-radius: var(--sp4x) !important;
	}

	.react-select__value-container {
		padding: var(--sp1x) !important;
	}

	.wrapper-gift-icon {
		background-color: var(--pink) !important;
	}

	.close-wrap {
		cursor: pointer;
	}

	.icon-close-popup {
		font-size: var(--h2) !important;
		cursor: pointer;
	}

	.promo-code-success-block {
		border: unset !important;
		background-color: rgba(176, 227, 217, 0.3) !important;

		p {
			color: var(--purple) !important;
		}
	}

	.counter-block {
		p {
			font-size: var(--h3) !important;
		}

		svg {
			stroke: var(--purple) !important;
		}
	}

	.inputs-wrap {
		.ant-form-item {
			input {
				padding: var(--sp1x) !important;
				border: 1px solid var(--grey) !important;
				font-size: var(--sp2x) !important;
			}
		}

		&.ant-form-item-has-error {
			border: 1px solid var(--coral) !important;
		}
	}

	.tabs-wrap {
		.menu-item {
			span {
				color: var(--black) !important;

				&:hover {
					color: var(--green) !important;
				}
			}
			&.active {
				span {
					color: var(--green) !important;
				}
			}
		}
	}

	.account-progress-status-wrapper {
		* {
			--account_secondaryColor9: var(--green) !important;
		}
	}

	.wrapper-progress-inner-info {
		#gradient stop:first-child {
			stop-color: var(--green);
		}
		#gradient stop:last-child {
			stop-color: var(--lightGreen);
		}
	}

	.collapse-distance {
		&.disable {
			#collapse-description {
				.btn-wrap {
					pointer-events: none !important;

					button {
						opacity: 0.5 !important;
						pointer-events: none !important;
						border-color: var(--lightGreen) !important;
						color: var(--purple) !important;
					}
				}
			}
		}
	}

	.step-review {
		.change-delivery-wrap,
		.title {
			margin-bottom: var(--form_labelDistance) !important;
		}

		.guest-contact-information-form {
			margin-top: var(--account_checkoutMTop) !important;
		}
	}

	.right-panel-wrap {
		.card-form-wrapper {
			gap: var(--gutter) !important;
		}
	}

	.form-wrapper .form-item.checkout-address-phone-autofill-mode {
		width: 50% !important;
		max-width: 50%;
		flex-basis: 50%;
		box-sizing: border-box;
	}

	.step-review .shipping-billing-change-wrapper {
		.item-container {
			display: flex;
			flex-direction: column;

			.item-internal-wrap {
				flex: 1;
				height: auto !important;
			}
		}
	}

	@media only screen and (min-width: 2560px) {
		* {
			--account_deliveryWrapperMTop: var(--sp7x) !important;
			--account_checkoutMTop: var(--sp7x) !important;
			--account_loginWrapperMaxWidth: var(--sp70x) !important;
			--account_signUpWrapperMaxWidth: var(--sp70x) !important;
			--account_forgotPasswordWrapperMaxWidth: var(--sp70x) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.DesktopSizeS}) {
		* {
			--account_deliveryWrapperMTop: var(--sp6x) !important;
			--account_checkoutMTop: var(--sp6x) !important;

			--account_loginWrapperMaxWidth: var(--sp70x) !important;
			--account_signUpWrapperMaxWidth: var(--sp70x) !important;
			--account_forgotPasswordWrapperMaxWidth: var(--sp70x) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.DesktopSizeXS}) {
		* {
			--account_deliveryWrapperMTop: var(--sp6x) !important;
			--account_checkoutMTop: var(--sp6x) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.TabletSize}) {
		* {
			--account_deliveryWrapperMTop: var(--sp5x) !important;
			--account_checkoutMTop: var(--sp5x) !important;

			--core_popupMaxWidth: 70% !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSizeS}) {
		* {
			--account_deliveryWrapperMTop: var(--sp5x) !important;
			--account_checkoutMTop: var(--sp5x) !important;

			--core_popupMaxWidth: 94% !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		* {
			--account_deliveryWrapperMTop: var(--sp4x) !important;
			--account_checkoutMTop: var(--sp4x) !important;

			--core_popupMaxWidth: 94% !important;
		}

		.checkout-address-autofill {
			width: 100% !important;
			padding-right: 0 !important;
		}

		.form-wrapper .form-item.checkout-address-phone-autofill-mode {
			width: 100% !important;
			padding-right: 0 !important;
			max-width: 100% !important;
			flex-basis: 100% !important;
		}
	}
`}`;
export default RewriteStyle;
